import React, { useState } from "react";
import * as Feather from "react-feather";
import { Link } from "react-router-dom";
import "../../styles/SideNavBar.css";
// import { useSelector } from "react-redux";

// MENU_ITEMS (equivalent of your interface)
export const MENU_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    Icon: Feather.Airplay,
    url: "/admin",
  },
  {
    key: "advertisement",
    label: "Advertisement",
    url: "/admin/advertisement",
    Icon: Feather.Cast,
  },
  // {
  //   key: "leave",
  //   label: "Leave",
  //   Icon: Feather.Layers,
  //   children: [
  //     {
  //       key: "leaverequest",
  //       label: "Leave Request",
  //       url: "/employeeLeave",
  //       Icon: Feather.Monitor,
  //     },
  //     {
  //       key: "leavehistory",
  //       label: "Leave History",
  //       url: "/leavehistory",
  //       Icon: Feather.Monitor,
  //     },
  //   ],
  // },
  {
    key: "sliders",
    label: "Sliders",
    url: "/admin/sliders",
    Icon: Feather.Sliders,
  },
  {
    key: "pages",
    label: "Pages",
    url: "/admin/pages",
    Icon: Feather.FileText,
  },
  {
    key: "posts",
    label: "Posts",
    Icon: Feather.UploadCloud,
    url: "/admin/posts",
  },
  {
    key: "users",
    label: "Users",
    Icon: Feather.Users,
    url: "/admin/user",
  },
  {
    key: "dropdown master",
    label: "Dropdown Master",
    Icon: Feather.ChevronDown,
    url: "/admin/dropdown",
  },
  // {
  //   key: "subscription",
  //   label: "Subscription",
  //   Icon: Feather.Bell,
  //   url: "/admin/subscripers",
  // },
  // {
  //   key: "subscription history",
  //   label: "Subscription History",
  //   Icon: Feather.Clock,
  //   url: "/admin/subscripersHistory",
  // },
  // {
  //   key: "category",
  //   label: "Category",
  //   Icon: Feather.Grid,
  //   url: "/admin/category",
  // },
  {
    key: "comments",
    label: "Comments",
    Icon: Feather.MessageCircle,
    url: "/admin/comments",
  },
];

const SideNavBarAdmin = () => {
  // const authUser = useSelector((state) => state.authUser);

  const renderMenuItem = (menuItem) => {
    const { Icon } = menuItem;
    return (
      <li className="nav-item" key={menuItem.key}>
        <Link to={menuItem.url || ""} className="nav-link">
          {Icon && <Icon style={{ marginRight: "5px" }} />}
          <p>{menuItem.label}</p>
        </Link>
      </li>
    );
  };

  return (
    <aside
      className="main-sidebar elevation-4"
      style={{ backgroundColor: "#10296C", position: "fixed" }}
    >
      <div className="sidebar">
        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
          <div className="info">
            <img
              src={
                process.env.PUBLIC_URL
                  ? process.env.PUBLIC_URL + "img/tasktracker.png"
                  : "../img/tasktracker.png"
              }
              width="1000px"
              alt="VVRHCS"
            />
          </div>
        </div>
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            data-accordion="false"
          >
            {MENU_ITEMS.map((menuItem) =>
              menuItem.children ? (
                <MenuItem key={menuItem.key} menuItem={menuItem} />
              ) : (
                renderMenuItem(menuItem)
              )
            )}
            <li className="nav-item">
              <Link to="/logout" className="nav-link">
                <Feather.LogOut style={{ marginRight: "5px" }} />
                <p>Logout</p>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

const MenuItem = ({ menuItem }) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const { Icon } = menuItem;

  const handleToggleMenuClick = (e) => {
    e.preventDefault();
    setShowSubMenu(!showSubMenu);
  };

  return (
    <li className="nav-item" key={menuItem.key}>
      <Link
        to="#"
        className="nav-link"
        onClick={handleToggleMenuClick}
        aria-expanded={showSubMenu}
      >
        {Icon && <Icon style={{ marginRight: "5px" }} />}
        <p>
          {menuItem.label}
          <i
            className={`right fas ${!showSubMenu ? "fa-angle-left" : "fa-angle-down"
              }`}
          ></i>
        </p>
      </Link>
      <ul
        className="nav nav-treeview"
        style={{ display: showSubMenu ? "block" : "none" }}
      >
        {menuItem.children?.map((childItem) => (
          <li className="nav-item" key={childItem.key}>
            <Link to={childItem.url || "#"} className="nav-link">
              <i className="fas fa-angle-right nav-icon"></i>
              <p>{childItem.label}</p>
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default SideNavBarAdmin;
